import { createFileRoute } from '@tanstack/react-router';
import { SpecRequirementsView } from '../components/features/spec-requirements/SpecRequirementsView.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件詳細ページの「要件定義」タブ。旧 /projects/spec/$pjKey と同じ SpecRequirementsView をそのままマウントする
 * @graph-connects SpecRequirementsView [calls] 成果物ビュー描画
 */
export const Route = createFileRoute('/projects/$pjKey/spec')({
  component: ProjectSpecTab,
});

/** @graph-connects SpecRequirementsView [calls] 成果物ビュー描画 */
function ProjectSpecTab() {
  const { pjKey } = Route.useParams();
  return <SpecRequirementsView pjKey={pjKey} />;
}
